import React from 'react'
import { emotions_color, emotions_heads, mainReasonList, mainReasonListIcons } from '../../../constants/Constants'
import { Oval } from 'react-loader-spinner'
import Loading from '../../Loading'
import { useTranslation } from 'react-i18next'

const MAX_CHARS = 160

function SelectReason({ selectedEmotion, submitEmotion, answer_text, setAnswerText, reasonsList, changeReasonsList, sendingEmotion }) {
    const { t, locale } = useTranslation()
    return (
        <div className="bg-background mt-[30px]  w-[620px] rounded-[10px]">
            <div>
                <div
                    className="flex flex-row-reverse items-center justify-between gap-[14px] py-[27px] px-[40px] rounded-[10px] "
                    // TODO color and heads
                    style={{ backgroundColor: `${emotions_color[selectedEmotion]}CC` }}
                >
                    <div>{!!selectedEmotion && <img src={emotions_heads[selectedEmotion]} alt="emotion" className={`w-[70px] h-[70px] `} />}</div>
                    <p className="text-[18px] text-center leading-[20px] font-bold  text-textDark capitalize">{t(selectedEmotion)}</p>
                    <div className="w-[70px]"></div>
                </div>
                <div className="pt-[19px] pb-[33px] px-[40px] ">
                    <p className="text-[18px] leading-[20px] font-bold  text-textDark">{t('whatIsTheMainReason')} </p>
                    <p className="text-[16px] leading-[20px] font-bold  text-textDark mt-[10px]">{t('pickUpTo3')}</p>
                    <div className="mt-[15px] flex flex-row items-center justify-between flex-wrap ">
                        {mainReasonList.map((item, index) => {
                            const isSelected = reasonsList.includes(item)
                            return (
                                <div
                                    className={`w-[166px] h-[40px] flex flex-row items-center justify-center gap-[10px] mb-[15px] cursor-pointer rounded-[48px] ${
                                        isSelected ? 'bg-lightMint' : 'bg-lightBlue'
                                    } `}
                                    onClick={() => changeReasonsList(item)}
                                    key={index}
                                >
                                    {React.cloneElement(mainReasonListIcons[index], {
                                        fill: isSelected ? 'var(--deep-ocean)' : 'var(--deep-ocean)',
                                    })}
                                    <p
                                        className="text-[16px] leading-[20px] font-semibold  text-textDark uppercase noselect text-center w-fit"
                                        style={{ color: isSelected ? 'var(--deep-ocean)' : 'var(--deep-ocean)' }}
                                    >
                                        {t(item.toLowerCase())}
                                    </p>
                                </div>
                            )
                        })}
                    </div>

                    <div className="flex-1 rounded-[10px] border border-grey p-[19px] ">
                        <textarea
                            className="w-[100%]  text-[16px] leading-[20px] font-medium resize-none rounded-[10px]  text-textDark"
                            placeholder={t("I think I'm feeling this way because")}
                            autoFocus={true}
                            rows={5}
                            value={answer_text}
                            maxLength={MAX_CHARS}
                            onChange={(e) => setAnswerText(e.target.value)}
                        ></textarea>
                        <div
                            style={{
                                marginTop: '4px',
                                textAlign: 'right',
                                fontSize: '14px',
                                color: '#5e639b',
                            }}
                        >
                            {MAX_CHARS - answer_text.length}/{MAX_CHARS}
                        </div>
                    </div>
                    <div className="flex items-center justify-center">
                        <button
                            className={`mt-[49px] rounded-[48px] min-h-[60px] w-[280px] cursor-pointer flex items-center justify-center  bg-deepOcean`}
                            onClick={submitEmotion}
                            disabled={selectedEmotion === '' || sendingEmotion}
                        >
                            {sendingEmotion ? (
                                <Loading primaryColor="var(--background)" secondaryColor="var(--grey)" size={25} stroke={7} />
                            ) : (
                                <p className={`text-[18px] font-semibold text-textLight`}>{t('continue')} </p>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SelectReason
